import { combineReducers } from "redux";

import map from "./map";
import topBar from "./topbar";
import window from "./window";

export default combineReducers({
    window,
    topBar,
    map,
});
